//LOGO
export const LOGO = '/assets/svg/sv_logo.svg'
export const LOGO_BLACK = '/assets/svg/sv_black.svg'
export const LOGO_WHITE = '/assets/images/sv_logo.png'
export const BRAND_LOGO = '/assets/images/songvestBLogo.png'
export const SITE_NAME = 'SongVest'
